import { render, staticRenderFns } from "./WorkHoursDetailed.vue?vue&type=template&id=648234ea"
import script from "./WorkHoursDetailed.vue?vue&type=script&lang=js"
export * from "./WorkHoursDetailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports